export const SET_PLAYER_VOLUME = 'SET_PLAYER_VOLUME';
export const SET_PLAYER_QUALITY = 'SET_PLAYER_QUALITY';
